import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalHeader,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb.js";
import Axios from "../../lib/Axios.js";
import PrivacyPolicyForm from "./helper/PrivacyPolicyForm.jsx";
import PrivacyPolicyCreateForm from "./helper/PrivacyPolicyCreateForm.jsx";
import PrivacyPolicyResetUserForm from "./helper/PrivacyPolicyResetUserForm.jsx";

const PrivacyPolicy = () => {
  const [data, setData] = useState([]);
  const [openTnC, setOpenTnC] = useState(false);
  const [addTnC, setAddTnC] = useState(false);
  const [resetUserTnC, setResetUserTnC] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [editData, setEditData] = useState(null);

  // Columns definition
  const columns = useMemo(
    () => [
      {
        name: (
          <span className="font-weight-bold fs-13">Privacy Policy Id</span>
        ),
        selector: (row) => row.TermOfUseId,
        sortable: true,
      },
      {
        name: <span className="font-weight-bold fs-13">Created at</span>,
        selector: (row) => new Date(row.createdAt).toLocaleString(),
        sortable: true,
      },
      {
        name: <span className="font-weight-bold fs-13">Updated at</span>,
        selector: (row) => new Date(row.updatedAt).toLocaleString(),
        sortable: true,
      },
      {
        name: <span className="font-weight-bold fs-13">Action</span>,
        cell: (row) => (
          <Button
            size="sm"
            color="success"
            onClick={() => handleEdit(row)}
            className="edit-item-btn"
          >
            Open
          </Button>
        ),
      },
    ],
    []
  );

  // Fetch list of terms and conditions
  const fetchList = async () => {
    try {
      const result = await Axios.post("/cms/cms-get/privacy-policy-list");
      setData(result?.data?.result?.results || []);
    } catch (error) {
      console.error("Error fetching terms and conditions:", error);
    }
  };

  // Toggle modals
  const toggleOpenTnC = () => setOpenTnC(!openTnC);
  const toggleAddTnC = () => setAddTnC(!addTnC);
  const toggleResetTnC = () => setResetUserTnC(!resetUserTnC);

  // Handle edit action
  const handleEdit = (row) => {
    setEditData(row);
    toggleOpenTnC();
  };

  // Filter data
  const filteredData = useMemo(() => {
    if (!data || !Array.isArray(data)) {
      return []; // Ensure data is an array before filtering
    }
    // Safely filter the data by converting TermOfUseId to a string
    return data.filter((item) =>
      item?.TermOfUseId?.toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [data, searchTerm]);

  useEffect(() => {
    fetchList();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Privacy Policy" />
          <Col lg={12}>
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">Manage Privacy Policy</h4>
              </CardHeader>
              <CardBody>
                <Row className="g-4 mb-3">
                  <Col sm="auto">
                    <Button color="success" onClick={toggleAddTnC}>
                      <i className="ri-add-line align-bottom me-1"></i> Add
                    </Button>
                  </Col>
                  <Col sm>
                    <Button color="success" onClick={toggleResetTnC}>
                      <i className="mdi mdi-account align-bottom me-1"></i>{" "}
                      Reset User Privacy Policy
                    </Button>
                  </Col>
                  <Col sm>
                    <div className="d-flex justify-content-sm-end">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
                <DataTable columns={columns} data={filteredData} pagination />
              </CardBody>
            </Card>
          </Col>
        </Container>
      </div>

      <Modal isOpen={openTnC} toggle={toggleOpenTnC} centered>
        <ModalHeader className="bg-light p-3" toggle={toggleOpenTnC}>
          Read Privacy Policy
        </ModalHeader>
        <PrivacyPolicyForm data={editData} refetch={fetchList} />
      </Modal>

      <Modal isOpen={addTnC} toggle={toggleAddTnC} centered>
        <ModalHeader className="bg-light p-3" toggle={toggleAddTnC}>
          Write Privacy Policy
        </ModalHeader>
        <PrivacyPolicyCreateForm refetch={fetchList} toggle={toggleAddTnC} />
      </Modal>

      <Modal isOpen={resetUserTnC} toggle={toggleResetTnC} centered>
        <ModalHeader className="bg-light p-3" toggle={toggleResetTnC}>
          Confirm reseting all user Privacy Policy
        </ModalHeader>
        <PrivacyPolicyResetUserForm refetch={fetchList} toggle={toggleResetTnC} />
      </Modal>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
